import { GET_BANNERS_LIST, ADD_NEW_BANNER, DELETE_BANNER, UPLOAD_BANNER } from './banners.constants'

export const getBannersList = (callback) => ({ type: GET_BANNERS_LIST, callback })

export const addNewBanner = (payload, callback) => ({ type: ADD_NEW_BANNER, payload, callback })

export const deleteBanner = (payload, callback) => ({ type: DELETE_BANNER, payload, callback })

export const uploadBanner = (payload, callback) => ({ type: UPLOAD_BANNER, payload, callback })